module.exports = __webpack_public_path__ + "img/004-windows.becda13e.svg";